import React, { memo, useEffect, useState } from 'react';
import cn from 'classnames';

import { CloseButton, Icons } from '@components/common';

import { EMapOverlayCardPositions, TMapOverlayCardPositions } from '@enums/map';

import styles from './MapOverlayCard.module.scss';

interface IMapOverlayCardProps {
	children: React.ReactNode;
	dynamicPosition?: {
		x: number;
		y: number;
	};
	handleClose: () => void;
	handleHide?: () => void;
	left?: number;
	position: TMapOverlayCardPositions;
	right?: number;
	top?: number;
	width?: number;
	withoutPadding?: boolean;
	closeButtonTopMargin?: number;
}

interface IPosition {
	top: string;
	left: string;
}

const ELEMENT_OFFSET = 15;
const PADDING_HIDE_ICON = 5;

const MapOverlayCard = ({
	children,
	dynamicPosition,
	handleClose,
	handleHide,
	left,
	position = EMapOverlayCardPositions.right,
	right,
	top,
	width,
	withoutPadding,
	closeButtonTopMargin,
}: IMapOverlayCardProps) => {
	const [elementPosition, setElementPosition] = useState<IPosition>({} as IPosition);

	useEffect(() => {
		if (position === 'dynamic' && dynamicPosition) {
			setElementPosition({
				top: `${dynamicPosition.y + ELEMENT_OFFSET}px`,
				left: `${dynamicPosition.x + ELEMENT_OFFSET}px`,
			});
		}
	}, [dynamicPosition, position]);

	const overlayStylesHideIcon = {
		top: `${top}px`,
		left: left ? `${left + (width || 0) + PADDING_HIDE_ICON}px` : (!right && !left) ? '0' : 'unset',
		right: right ? `${right + (width || 0) + PADDING_HIDE_ICON}px` : 'unset',
	};

	const overlayStyles = position === 'dynamic'
		? {
			...elementPosition,
			width: width ? `${width}px` : 'auto',
		}
		: {
			width: width ? `${width}px` : 'auto',
			top: `${top}px`,
			left: left ? `${left}px` : (!right && !left) ? '0' : 'unset',
			right: right ? `${right}px` : 'unset',
		};

	return (
		<>
			<div
				className={cn(styles.overlayCardContainer, styles[position], {
					[styles.withoutPadding]: withoutPadding,
				})}
				style={overlayStyles}
			>
				{children}
				<div
					className={styles.closeButton}
					style={{ top: closeButtonTopMargin }}
				>
					<CloseButton onClick={handleClose} />
				</div>
			</div>
			{!!handleHide
				&& <div
					className={cn(styles.hideButton)}
					onClick={handleHide}
					style={overlayStylesHideIcon}
				>
					{left ? Icons.chevronsLeft() : Icons.chevronsRight()}
				</div>
			}
		</>
	);
};

export default memo(MapOverlayCard);
